module.exports = __webpack_public_path__ + "img/11.417763b7.svg";